<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    left
    :nudge-width="350"
    max-width="300"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn small
             color="primary"
             class="normal-btn-text elevation-0 rounded-tag-small"
             v-on="on">
        Gerar
        <v-icon small right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-card >
      <v-card-text class="text--primary ma-0 pa-0 px-2">
        <v-list dense>
          <v-list-item @click="onClickGerarCotacao">
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Gerar cotação
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="onClickGerarCompra">
            <v-list-item-icon>
              <v-icon>mdi-shopping</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Gerar compra
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    produtos: {
      type: Array,
    },
  },
  data() {
    return {
      menuOpened: false,
    };
  },
  methods: {
    onClickGerarCompra() {
      this.$router.push({
        name: 'main.compras.requisicao-compra',
        query: {
          idsRequisicoes: this.produtos.map(p => p.id).join(','),
        },
        params: {
          isRascunho: false,
        },
      });
    },
    onClickGerarCotacao() {
      this.$router.push({
        name: 'main.cotacoes.requisicao-cotacao',
        query: {
          idsRequisicoes: this.produtos.map(p => p.id).join(','),
        },
        params: {
          isRascunho: false,
        },
      });
    },
  },
};
</script>
